import React from 'react';

import './styles.scss';

interface Props {
    label: string | React.ReactElement;
    value: string | number | React.ReactElement;
}

export default function JobField(props: Props): React.ReactElement {
    const { label, value } = props;

    return (
        <div className="job-field">
            <div className="job-field-label">{label}</div>
            {value}
        </div>
    );
}
